module.exports = __webpack_public_path__ + "img/zhuanjiacaozuo.27a5e800.png";